'use es6';

import { combineReducers } from 'redux';
import Auth from 'documents-lib/js/reducers/Auth';
import View from 'documents-lib/js/reducers//View';
import LegalConsent from 'documents-lib/js/reducers//LegalConsent';
export default combineReducers({
  auth: Auth,
  view: View,
  legalConsent: LegalConsent
});